package com.anjuros.website.redesign.sections.home

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdGhostButton
import com.anjuros.website.redesign.components.RdLink
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.components.RdTag
import com.anjuros.website.redesign.styles.HomeDesignBadgeStyle
import com.anjuros.website.redesign.styles.HomeDesignBodyStyle
import com.anjuros.website.redesign.styles.HomeDesignCardLeadStyle
import com.anjuros.website.redesign.styles.HomeDesignCardStyle
import com.anjuros.website.redesign.styles.HomeDesignGoStyle
import com.anjuros.website.redesign.styles.HomeDesignLeadFigureStyle
import com.anjuros.website.redesign.styles.HomeDesignsFootStyle
import com.anjuros.website.redesign.styles.HomeDesignsGridStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.styles.RdPillStyle
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdRoute
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.thenIf
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

private class DesignCard(
    val path: String,
    val image: RdImage.Asset,
    val alt: RdText,
    val title: RdText,
    val text: RdText,
    val featured: Boolean = false,
)

private val DesignCards = listOf(
    DesignCard(
        RdRoute.ELECTRICIAN, RdImage.DESIGN_ELECTRICIAN, RdText.HOME_DESIGN_ELECTRICIAN_ALT,
        RdText.HOME_DESIGN_ELECTRICIAN, RdText.HOME_DESIGN_ELECTRICIAN_TEXT, featured = true
    ),
    DesignCard(
        RdRoute.DECORATOR, RdImage.DESIGN_DECORATOR, RdText.HOME_DESIGN_DECORATOR_ALT,
        RdText.HOME_DESIGN_DECORATOR, RdText.HOME_DESIGN_DECORATOR_TEXT
    ),
    DesignCard(
        RdRoute.HANDYMAN, RdImage.DESIGN_HANDYMAN, RdText.HOME_DESIGN_HANDYMAN_ALT,
        RdText.HOME_DESIGN_HANDYMAN, RdText.HOME_DESIGN_HANDYMAN_TEXT
    ),
)

@Composable
fun HomeDesignsSection() {
    RdSection(id = "designs", labelledBy = "designs-h") {
        RdSectionHead(RdText.HOME_DESIGNS_EYEBROW, "designs-h", RdText.HOME_DESIGNS_TITLE, RdText.HOME_DESIGNS_LEDE)
        Div(HomeDesignsGridStyle.toModifier().toAttrs()) {
            DesignCards.forEach { DesignCardView(it) }
        }
        Div(HomeDesignsFootStyle.toModifier().toAttrs()) {
            P { Text(LocalText(RdText.HOME_DESIGNS_MORE)) }
            RdGhostButton(RdRoute.DESIGNS, RdText.HOME_DESIGNS_BROWSE, withArrow = true)
        }
    }
}

@Composable
private fun DesignCardView(card: DesignCard) {
    RdLink(card.path, HomeDesignCardStyle.toModifier().thenIf(card.featured, HomeDesignCardLeadStyle.toModifier())) {
        if (card.featured) {
            Span(RdPillStyle.toModifier().then(HomeDesignBadgeStyle.toModifier()).toAttrs()) {
                Text(LocalText(RdText.FEATURED))
            }
        }
        RdTag("figure", if (card.featured) HomeDesignLeadFigureStyle.toModifier() else Modifier) {
            RdPicture(card.image, LocalText(card.alt))
        }
        Div(HomeDesignBodyStyle.toModifier().toAttrs()) {
            Div {
                H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(card.title)) }
                P { Text(LocalText(card.text)) }
            }
            Span(HomeDesignGoStyle.toModifier().attrsModifier { attr("aria-hidden", "true") }.toAttrs()) { Text("→") }
        }
    }
}
